import ChqModalDialog from "components/common/ChqModalDialog";
import React, { useEffect, useState } from "react";
import { useProfile } from "app/context";
import { makePatch, makePost } from "@culturehq/client";
import { Button, Loader, ModalDialog, Subnav } from "@culturehq/components";
import { t, Trans } from "app/utils";
import { useGet } from "app/hooks";
import { EngagementCost, ImpressionCost } from "./types";
import ImpressionsTab from "./ImpressionsTab";
import EngagementTab from "./EngagementTab";

type EmvModalProps = {
  onClose: () => void;
};

const EarnedMediaValueModal: React.FC<EmvModalProps> = ({ onClose }) => {
  const { got: data, getting, error }: any = useGet("/organization_engagement_costs");
  const { profile } = useProfile();
  const [tabIndex, setTabIndex] = useState(0);
  const [impressionsCost, setImpressionsCost] = useState<ImpressionCost[]>([]);
  const [engagementCost, setEngagementCost] = useState<EngagementCost[]>([]);
  const { socialMediaTypes } = profile.organization;
  const isImpressionsTab = tabIndex === 0;

  useEffect(() => {
    if (!data) return;

    setImpressionsCost(
      data.impressionTotalCosts.map((ic: any) => (({
        id: ic.id,
        socialMediaType: ic.socialMediaType.name.toLowerCase(),
        cost: parseFloat(ic.cost)
      })))
    );

    setEngagementCost(
      data.engagementCosts.map((ec: any) => (({
        id: ec.id,
        socialMediaType: ec.socialMediaType.name.toLowerCase(),
        likesCost: parseFloat(ec.likesCost),
        commentsCost: parseFloat(ec.commentsCost),
        sharesCost: parseFloat(ec.sharesCost)
      })))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleSave = async () => {
    impressionsCost.forEach(ic => (
      ic.id
        ? makePatch(`/impression_total_costs/${ic.id}`, { ...ic })
        : makePost("/impression_total_costs", { ...ic }))
    );
    engagementCost.forEach(ec => (
      ec.id
        ? makePatch(`/engagement_costs/${ec.id}`, { ...ec })
        : makePost("/engagement_costs", { ...ec })
    ));

    onClose();
  };

  if (error) {
    throw new Error(t("Looks like there has been an unexpected error. Please reload the page."));
  }

  return (
    <ChqModalDialog onClose={onClose} className="earned_media_value">
      <ModalDialog.Heading onClose={onClose}>
        <Trans>Edit Earned Media Value</Trans>
      </ModalDialog.Heading>
      {getting ? <Loader loading />
        : (
          <>
            <ModalDialog.Body>
              <Subnav onChange={setTabIndex}>
                <Subnav.Item key="impressions">Impressions</Subnav.Item>
                <Subnav.Item key="engagement">Engagement</Subnav.Item>
              </Subnav>
              {isImpressionsTab
                ? (
                  <ImpressionsTab
                    socialMediaTypes={socialMediaTypes}
                    costs={impressionsCost}
                    setCost={setImpressionsCost}
                  />
                )
                : (
                  <EngagementTab
                    socialMediaTypes={socialMediaTypes}
                    costs={engagementCost}
                    setCost={setEngagementCost}
                  />
                ) }
            </ModalDialog.Body>
            <ModalDialog.Footer>
              <div>
                <Button inverted onClick={onClose}>
                  <Trans>Close</Trans>
                </Button>
              </div>
              <Button primary onClick={handleSave}>
                <Trans>Save</Trans>
              </Button>
            </ModalDialog.Footer>
          </>
        )}
    </ChqModalDialog>
  );
};

export default EarnedMediaValueModal;
